import moment, { type Moment } from "moment";

// A picked date without a time resolves to midnight, so "today" with no time already counts as past.
export const isMomentInPast = (value: Moment | null | undefined): boolean =>
    !!value && value.isValid() && value.isBefore(moment());

export const formatDateWithTime = (date: number | string | undefined, dateTranslation: string): string => {
    if (!date) return "";
    // Handle both ISO string and milliseconds
    const dateToFormat = typeof date === "string" ? moment(date) : moment.unix(date / 1000);
    return `${dateToFormat.format("DD.MM.YYYY - HH:mm")} ${dateTranslation}`;
};

// Class member dates ("Oct 12, 2026 1:49:14 PM", server local time) need the English locale: the app
// switches moment to German, where "Oct" is not a month.
const CLASS_MEMBER_DATE_FORMAT = "MMM D, YYYY h:mm:ss A";
const CLASS_MEMBER_DATE_LOCALE = "en";

// The BE expects epoch ms, but legacy records may still hold ISO strings.
export const toEpochMs = (value: number | string | null | undefined): number | null => {
    if (!value) return null;
    if (typeof value === "string") {
        const strict = moment(value, CLASS_MEMBER_DATE_FORMAT, CLASS_MEMBER_DATE_LOCALE, true);
        if (strict.isValid()) return strict.valueOf();
    }
    const parsed = moment(value);
    return parsed.isValid() ? parsed.valueOf() : null;
};

// Harmonizes a record's timestamps at the write boundary — spread AFTER the record so
// legacy ISO values are replaced before being sent to the BE.
export const toEpochMsTimestamps = (record: { createdDate?: number | string; updatedDate?: number | string }) => ({
    createdDate: toEpochMs(record.createdDate) ?? undefined,
    updatedDate: toEpochMs(record.updatedDate) ?? undefined,
});
